const ListingsRoutes = [
  {
    path: '',
    name: 'listings',
    component: () => import(/* webpackChunkName: "listingsRoot" */ '@/views/Tasklist/TasklistRoot'),
  },
  {
    path: 'task/:id',
    name: 'taskActivity',
    component: () => import(/* webpackChunkName: "taskActivity" */'@/views/Tasklist/TaskActivity')
  },
  {
    path: 'task/text/:id',
    name: 'taskText',
    component: () => import(/* webpackChunkName: "taskActivity" */'@/views/Tasklist/TaskText')
  },
  {
    path: 'quest/:id',
    name: 'questActivity',
    component: () => import(/* webpackChunkName: "questActivity" */'@/views/Tasklist/QuestActivity')
  },
  {
    path: 'quest/text/:id',
    name: 'questText',
    component: () => import(/* webpackChunkName: "questActivity" */'@/views/Tasklist/QuestText')
  }
]

export default ListingsRoutes
